interface Props {
	gap?: number;
	children: React.ReactElement | React.ReactElement[];
}

const SimpleFlex = ({ gap, children }: Props) => {
	return <div style={{ display: "flex", gap: gap ? gap : 0 }}>{children}</div>;
};

export default SimpleFlex;
